import React, { Component, PropTypes } from 'react';
import { Row, Col, Progress } from 'antd';
import editIcon from '../../assets/common/img/okr/edit.png';
import refreshIcon from '../../assets/common/img/okr/refresh.png';

class OKRInfoSlider extends Component {
  constructor(props) {
    super(props)
  }

  updateSlider = () => {
    if (this.props.callback) {
      this.props.callback(this.props.target);
    }
  }

  updateKR = () => {
    if (this.props.updateKR) {
      this.props.updateKR(this.props.target);
    }
  }

  render() {
    const { title, target, updateKR } = this.props;
    return (
      <Row className="kr-list-item">
        <Col span={12}>
          <p className="item-title">
            <span>{target.title}</span>
            {
              this.props.isOpen ? (
                <img className="edit-kr-icon" src={editIcon} onClick={this.updateKR} />
              ) : null
            }
          </p>
          <p>
            {target.description}
          </p>
        </Col>

        <Col span={12}>
          <Row className="my-object-item-content">
            <Col span={12} style={{ textAlign: 'left' }}>
              <p style={{ marginBottom: 0 }}>&nbsp;</p>
              <p className="item-title">权重:{target.weightE2}</p>
            </Col>
            <Col span={10} style={{ textAlign: 'left'}}>
              <p>{target.currentValue + '/' + target.endValue}</p>
              <Progress
                percent={target.percentE2}
                strokeWidth={5}
                showInfo={false}
              />
            </Col>
            <Col span={2} style={{ textAlign: 'right' }}>
              <p style={{ marginBottom: 0 }}>&nbsp;</p>
              {
                this.props.isOpen ? (
                  <p><img className="refresh-kr-icon" src={refreshIcon} onClick={this.updateSlider} /></p>
                ) : null
              }

            </Col>
          </Row>
        </Col>
      </Row>
    )
  }
}

export default OKRInfoSlider;



// WEBPACK FOOTER //
// ./src/components/okr_manage/okr_info_with_slider.js